"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _simplebarReact = _interopRequireDefault(require("simplebar-react"));

var _excluded = ["autoHide", "className", "classes", "children", "height"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (_ref) {
  var breakpoints = _ref.breakpoints,
      palette = _ref.palette,
      typography = _ref.typography;
  return {
    root: {
      width: "100%",
      "& .simplebar-wrapper": {
        height: function height(props) {
          return props.height;
        }
      },
      "& .simplebar-track": {
        width: "50%",
        backgroundColor: "#f1f1ed",
        // off-white
        height: typography.pxToRem(8)
      },
      "& .simplebar-track.simplebar-horizontal": _defineProperty({}, breakpoints.up("md"), {
        marginLeft: "25%"
      }),
      "& .simplebar-track.simplebar-horizontal .simplebar-scrollbar": {
        backgroundColor: palette.primary.light,
        height: typography.pxToRem(8),
        top: 0,
        "&::before": {
          backgroundColor: palette.primary.light
        }
      }
    }
  };
});

function ScrollBar(_ref2) {
  var autoHide = _ref2.autoHide,
      className = _ref2.className,
      classesProp = _ref2.classes,
      children = _ref2.children,
      height = _ref2.height,
      props = _objectWithoutProperties(_ref2, _excluded);

  var classes = useStyles(_objectSpread({
    classes: classesProp,
    height: height
  }, props));

  if (!children) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_simplebarReact["default"], _extends({}, props, {
    autoHide: autoHide,
    height: height,
    className: (0, _clsx["default"])(classes.root, className)
  }), children);
}

ScrollBar.propTypes = {
  autoHide: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  classes: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired // in px

};
ScrollBar.defaultProps = {
  autoHide: false,
  children: undefined,
  classes: undefined,
  className: undefined
};
var _default = ScrollBar;
exports["default"] = _default;